module.exports = __webpack_public_path__ + "img/selected6-min.581fba61.png";